import React from 'react';
import List from '../ui/List';

const StudentList = ({ students }) => {
    const renderStudent = (student) => (
        <li key={student.id} className="py-3 flex justify-between items-center">
            <div className="flex flex-col">
                <span className="font-semibold">{student.name}</span>
                <span className="text-sm text-gray-500">{student.email}</span>
            </div>
        </li>
    );

    return (
        <div>
            <h3 className="text-lg font-semibold mb-2">Students</h3>
            <List items={students} renderItem={renderStudent} />
        </div>
    );
};

export default StudentList;
